import React from "react";
import Layout from "../Componants/Layout";
import { Col, Container, Row } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getRequest, postRequest, putRequest } from "../services/apiMethods";

export default function RegisPasswordSet() {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const { data: userDetails, error: userError, isLoading: userLoading } = useQuery({
    queryKey: ["userDetails", userId],
    queryFn: () => getRequest(`profile/info?id=${userId}`),
    enabled: !!userId,
  });

  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: (data) => {
      return postRequest(`/auth/register`, data);
    },
    onSuccess: (data) => {
      localStorage.removeItem("referId")
      toast.success(`${data?.message}`, {
        iconTheme: {
            primary: '#337FE0',
            secondary: '#FFFAEE',
        },
    })
    navigate("/registration-otp")
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });


  // Formik setup
  const formik = useFormik({
    initialValues: {
      newPassword: userDetails?.password ? userDetails?.password : "",
      confirmPassword:  userDetails?.password ? userDetails?.password : ""
    },
      enableReinitialize:true,
    validationSchema: Yup.object({
      newPassword: Yup.string()
        .required("New Password is required")
        .min(6, "Password must be at least 6 characters"),
      confirmPassword: Yup.string()
        .required("Please confirm your new password")
        .oneOf([Yup.ref("newPassword"), null], "Passwords must match"),
    }),
    onSubmit: (values) => {
      const modifyData = {
        isCompleted: true,
        password: values?.newPassword,
        id: userId,
        role: "Vendor",
      };
      mutate(modifyData);
    },
  });

  return (
    <>
      <Layout>
        <Container>
          <div className="dashboard-main">

            <Row>
              <Col lg={8}>
                <div className="my-profile-card-contain">
                  <div className="my-profile-title">
                    <h4>Password & Security</h4>
                  </div>
                  <div className="my-profile-box-contain">
                    <div className="my-profile-box-form">
                      <div className="form-box-title">
                        <h4>Set Password</h4>
                        <p>Set your account password.</p>
                      </div>
                      <div className="h-100 m-0">
                        <form
                          className="cmn-form-set"
                          onSubmit={formik.handleSubmit}
                        >
                    
                          <div className="mb-3">
                            <label>New Password</label>
                            <input
                              type="password"
                              name="newPassword"
                              placeholder="*********"
                              className="form-control"
                              value={formik.values.newPassword}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.newPassword && formik.errors.newPassword && (
                              <div className="text-danger">
                                {formik.errors.newPassword}
                              </div>
                            )}
                          </div>

                          <div className="mb-3">
                            <label>Re-Enter New Password</label>
                            <input
                              type="password"
                              name="confirmPassword"
                              placeholder="*********"
                              className="form-control"
                              value={formik.values.confirmPassword}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.confirmPassword &&
                              formik.errors.confirmPassword && (
                                <div className="text-danger">
                                  {formik.errors.confirmPassword}
                                </div>
                              )}
                          </div>

                          <div className="registration-form-action">
                              <button
                                className="theme-btn set-password-back"
                                type="button"
                                onClick={() =>
                                  navigate("/registration-business")
                                }
                              >
                                Back
                              </button>
                              <button className="white-btn set-password-next" type="submit">
                                Next
                              </button>
                            </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={4}></Col>
            </Row>
          </div>
        </Container>
      </Layout>
    </>
  );
}
